import apiClient from './apiClient';

const referralService = {
  // Get referrals for current user
  getMy: async (params = {}) => {
    const response = await apiClient.get('/referrals/my', { params });
    return response.data;
  },

  // Admin: get all referrals with pagination/filtering
  getAll: async (params = {}) => {
    const response = await apiClient.get('/referrals', { params });
    return response.data;
  },

  // Get single referral
  getById: async (id) => {
    const response = await apiClient.get(`/referrals/${id}`);
    return response.data;
  }
,
  // Admin: apply missing rewards
  applyMissingRewards: async () => {
    const response = await apiClient.post('/referrals/apply-missing-rewards');
    return response.data;
  }
};

export default referralService;
